import React from 'react';
import classNames from "classnames";
import styles from "../styles/match-event.module.scss";
import {observer} from 'mobx-react';
import {Image} from "../../../../../core/components/image/image";
import {ClockAssetsRequestParams} from "../../../../../core/icons/clock";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";

export const MatchEventsModuleFooter = observer(({controller}) => {
  const {state: {shouldRenderFooter}} = controller;
  const imageProps = {
    src: new ClockAssetsRequestParams(16, 16, useThemeColor(COLORS.textSecondary)),
    className: classNames(styles.clock_icon),
  }

  return (
    shouldRenderFooter ? <div className={classNames(styles.footer)}>
      <Image {...imageProps}/>
    </div> : null
  )
});
